import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ZiroCdrDumpComponent } from './cdr-dump.component';
import { SharedModule } from '../shared/shared.module';
import { ZiroButtonComponent } from '../button/button.component';
import { FormsModule } from '@angular/forms';
import { ZiroFormsModule } from '../forms/ziro-forms.module';
import { TopNavModule } from '../shared/top-nav/top-nav.module';
import { BreadcrumbsModule } from '../shared/breadcrumbs/breadcrumbs.module';
import { BottomNavModule } from '../shared/bottom-nav/bottom-nav.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    SharedModule,
    ZiroButtonComponent,
    FormsModule,
    ZiroFormsModule,
    TopNavModule,
    BreadcrumbsModule,
    BottomNavModule,
  ],
  declarations: [ZiroCdrDumpComponent],
  exports: [ZiroCdrDumpComponent],
})
export class CdrDumpModule {}
